<script setup lang="ts">
import { Select, InputGroup, InputGroupAddon } from 'primevue';
import { onMounted, ref } from 'vue';
import { useSelectedSiteStore } from '../stores/selectedSiteStore';
import { useSiteStore } from '../stores/siteStore';
import { storeToRefs } from 'pinia';
import type { SiteResponse } from '../api/listSites';

const selectedSiteStore = useSelectedSiteStore();
const siteStore = useSiteStore();

const { sites } = storeToRefs(siteStore);

const selectedSiteId = ref<number>();
const options = ref<SiteResponse[]>([]);

onMounted(async () => {
  await siteStore.initialize();
  options.value = siteStore.sites;
  const selectedId = selectedSiteStore.siteId;
  if (!selectedId) return;
  selectedSiteId.value = selectedId;
});

function onSiteChanged() {
  const id = selectedSiteId.value;
  if (!id) return;

  selectedSiteStore.select(id);
}

</script>

<template>
  <InputGroup v-if="options.length > 0" class="site-select">
    <InputGroupAddon>
      <i class="pi pi-warehouse"></i>
    </InputGroupAddon>
    <Select @change="onSiteChanged" v-model:model-value="selectedSiteId" :options="sites" optionLabel="name"
      option-value="id">
    </Select>
  </InputGroup>

</template>

<style scoped>
.site-select {
  width: unset;
  min-width: 10rem;
}
</style>
